export enum SigninMutations {
  RESET = "RESET",
  SET_RESET_CONFIRMATION = "SET_RESET_CONFIRMATION",
  CLEAR_RESET_PASSWORD = "CLEAR_RESET_PASSWORD",
  SET_VERIFICATION_TOKEN = "SET_VERIFICATION_TOKEN",
  SET_NEW_PASSWORD_CONFIRMATION = "SET_NEW_PASSWORD_CONFIRMATION",
  CLEAR_NEW_PASSWORD = "CLEAR_NEW_PASSWORD",
}
